import { Divider, Stack, Text, Title, useMantineTheme } from '@mantine/core'
import React, { useCallback, useState } from 'react'

import RootButton from '../../../Buttons/RootButton'
import { SchemaProperty } from '../../Templates/utils'
import SchemaReader from './SchemaReader'

interface PropertiesProps {
  prevStep: () => void
  nextStep: () => void
  metadata: any
  saveDraft: () => void
  properties: any
  setProperties: (properties: any) => void
}

const Properties: React.FC<PropertiesProps> = ({
  prevStep,
  nextStep,
  metadata,
  saveDraft,
  properties,
  setProperties,
}) => {
  const theme = useMantineTheme()
  const [disableContinue, setDisableContinue] = useState<boolean>(false)

  const { title, description, attributes } = metadata.properties

  const next = useCallback(() => {
    saveDraft()
    nextStep()
  }, [nextStep, saveDraft])

  return (
    <Stack>
      <Divider />
      <Stack style={{ flexDirection: 'row', gap: '15px', alignItems: 'center' }}>
        <Title order={3}>{title}</Title>
        {/* <Text
          style={{
            color: theme.colors.textAndIcon[0],
            fontSize: '14px',
            fontFamily: 'monument-grotesk-regularitalic',
          }}
        >
          * Required
        </Text> */}
      </Stack>
      <Text style={{ color: theme.colors.textAndIcon[1], fontSize: '14px', textAlign: 'left' }}>
        {description}
      </Text>

      {Object.entries(attributes).map(([key, value]) => (
        <Stack key={key} style={{ flexDirection: 'column', gap: '10px' }}>
          <SchemaReader
            keyName={key}
            schema={value as SchemaProperty}
            properties={properties}
            setProperties={setProperties}
            setDisableContinue={setDisableContinue}
          />
        </Stack>
      ))}

      <Stack style={{ flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
        <RootButton secondary onClick={prevStep}>
          Previous
        </RootButton>
        <RootButton onClick={next} disabled={disableContinue}>
          Continue
        </RootButton>
      </Stack>
    </Stack>
  )
}
export default Properties
